import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose } from 'class-transformer';

export class CAN3Status extends AdditionalInfoImpl {
  @Expose({ name: 'line' })
  line: string;

  @Expose({ name: 'direction' })
  direction: string;

  @Expose({ name: 'busstop_name' })
  busStopName: string;

  @Expose({ name: 'speed' })
  speed: number;

  @Expose({ name: 'user_name' })
  userName: string;

  @Expose({ name: 'people_count' })
  peopleCount?: number;

  @Expose({ name: 'aircond' })
  airConditioning: boolean;

  @Expose({ name: 'battery_working' })
  batteryWorking: boolean;

  @Expose({ name: 'traction_working' })
  tractionWorking: boolean;

  @Expose({ name: 'traction_voltage' })
  tractionVoltage?: number;

  @Expose({ name: 'battery_voltage' })
  batteryVoltage?: number;

  @Expose({ name: 'battery_percentage' })
  batteryPercentage?: number;
}
